import { VhcRecordLogService } from 'api/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

export type DeleteCheckLabourInput = {
  logId: number;
  itemId: number;
  labourId: number;
};

export const useDeleteCheckLabourMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof VhcRecordLogService.deleteVhcRecordsItemsChecksLabours>>,
      QueryError,
      DeleteCheckLabourInput,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ logId, itemId, labourId }: DeleteCheckLabourInput) => {
      return VhcRecordLogService.deleteVhcRecordsItemsChecksLabours(logId, itemId, labourId);
    },
    {
      ...options
    }
  );
